// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu_sideMenu__39wRE"};